const updateTrialAccess = (store, access) => {
  if (!access) return;

  const user = store.getters.getUser;
  if (user) {
    store.dispatch("setUser", { ...user, trial_access: access });
  }
};

const trialAccessErrorMessage = (error) => {
  const reason = error?.response?.data?.reason;

  if (reason === "exporter_not_integrated") {
    return "Esta exportação ainda não está integrada ao controle do trial.";
  }
  if (reason === "trial_expired") {
    return "O período de sete dias do trial terminou.";
  }
  if (reason === "email_confirmation_required") {
    return "Confirme seu e-mail para iniciar o trial.";
  }
  if (reason && reason.endsWith("_quota_consumed")) {
    return "A cota deste módulo foi consumida.";
  }
  if (reason && reason.endsWith("_quota_reserved")) {
    return "Todas as unidades deste módulo estão reservadas por operações em andamento.";
  }

  return "Este módulo não está disponível para a conta selecionada.";
};

module.exports = {
  trialAccessErrorMessage,
  updateTrialAccess,
};
